<script lang="ts">
	const particles = Array.from({ length: 15 }, () => ({
		left: `${Math.random() * 100}%`,
		top: `${Math.random() * 100}%`,
		opacity: 0.1 + Math.random() * 0.3,
		duration: `${5 + Math.random() * 10}s`,
		delay: `${-Math.random() * 10}s`
	}));
</script>

<div class="particle-container">
	{#each particles as particle, index (index)}
		<div
			class="particle"
			style:left={particle.left}
			style:top={particle.top}
			style:opacity={particle.opacity}
			style:animation-duration={particle.duration}
			style:animation-delay={particle.delay}
		></div>
	{/each}
</div>

<style>
	.particle-container {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		overflow: hidden;
	}

	.particle {
		position: absolute;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.5);
		box-shadow: 0 0 10px 2px rgba(255, 255, 255, 0.3);
		animation: float 15s ease-in-out infinite;
	}

	@keyframes float {
		0% {
			transform: translateY(0) translateX(0);
		}
		33% {
			transform: translateY(-30px) translateX(20px);
		}
		66% {
			transform: translateY(20px) translateX(-10px);
		}
		100% {
			transform: translateY(0) translateX(0);
		}
	}
</style>
